import React, { useState, useEffect } from "react";
import "../enquire/sortandfilter/EditSortBy.css";
import AbstractButton from "../components/AbstractButton";
import ForegroundColorSet from "../../utilities/enums/ForegroundColorSet";
import BackgroundColorSet from "../../utilities/enums/BackgroundColorSet";
import { ReactComponent as OkayIcon } from "../../assets/icons/checkbox-checked-regular.svg?react";
import StockCheckExtractSearch, {
  StockSearchOrderOption,
} from "../../interfaces/SceSearch";
import { OrderDirection } from "../../interfaces/PartSearch";

export interface StockFilterEditorProps {
  searchData: StockCheckExtractSearch;
  visibilityClassName: string;
  onShowTrigger: number;
  onCancelCallback(search: StockCheckExtractSearch): void;
  onOkayCallback(data: StockCheckExtractSearch): void;
}
const StockSortBy = (props: StockFilterEditorProps) => {
  const [localSearchData, setLocalSearchData] = useState(props.searchData);

  useEffect(() => {
    setLocalSearchData(props.searchData);
  }, [props.searchData]);

  const handleSortChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchData({
      ...localSearchData,
      Order: event.target.value as StockSearchOrderOption,
    });
  };

  const handleDirectionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLocalSearchData({
      ...localSearchData,
      OrderDirection: event.target.value as OrderDirection,
    });
  };

  const handleDone = () => {
    props.onOkayCallback(localSearchData);
  };

  return (
    <div
      id="search-and-filter-modal"
      className={`filter-modal-contents ${props.visibilityClassName}`}
    >
      <div className="flex-items">
        <h1 className="sort-and-filter-header">Sort By</h1>
      </div>
      <div className="flex-items">
        <hr></hr>
      </div>
      <table className="filter-options-table">
        <tbody>
          {Object.values(StockSearchOrderOption).map((option) => (
            <tr className="sort-options-row sort-by" key={option}>
              <td className="filter-option-label-cell-extended">
                <label className="filter-option-label" htmlFor={option}>
                  {option.split(/(?=[A-Z])/).join(" ")}
                </label>
              </td>
              <td className="filter-option-value-cell">
                <input
                  type="radio"
                  name="order-group"
                  className="checkbox-style"
                  value={option}
                  checked={localSearchData.Order === option}
                  onChange={handleSortChange}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex-items">
        <hr></hr>
      </div>

      <table className="filter-options-table">
        <tbody>
          {Object.values(OrderDirection).map((option) => (
            <tr className="sort-options-row sort-by" key={option}>
              <td className="filter-option-label-cell-extended">
                <label className="filter-option-label" htmlFor={option}>
                  {option == OrderDirection.Ascending
                    ? "Ascending"
                    : "Descending"}
                </label>
              </td>
              <td className="filter-option-value-cell">
                <input
                  type="radio"
                  name="direction-group"
                  className="checkbox-style"
                  value={option}
                  checked={localSearchData.OrderDirection === option}
                  onChange={handleDirectionChange}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex-items">
        <hr></hr>
      </div>

      <div>
        <span className="filter-modal-button-span">
          <AbstractButton
            id="sort-okay-button"
            text="Done"
            icon={<OkayIcon width="100%" height="100%" />}
            disabled={false}
            activeColor={ForegroundColorSet.Green}
            background={BackgroundColorSet.Black1}
            actionCallback={handleDone}
            specialClass="modal-button"
          />
        </span>
      </div>
    </div>
  );
};

export default StockSortBy;
